var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('LoginState',{directives:[{name:"show",rawName:"v-show",value:(_vm.windowWidth > 769),expression:"windowWidth > 769"}]}),_c('router-view'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }